"use client";
import { RefreshCw } from "lucide-react";
import { Alert } from "@clarityos/ui/alert";
import { Button } from "@clarityos/ui/button";

interface StripeInitErrorProps {
  message: string;
  onRetry: VoidFunction;
}

export function StripeInitError({ message, onRetry }: StripeInitErrorProps) {
  return (
    <div className="flex flex-col gap-5">
      <Alert severity="error" message={message} />
      <Button
        onClick={onRetry}
        variant="secondary"
        startIcon={({ className }) => (
          <RefreshCw className={className} strokeWidth={2.5} />
        )}
      >
        Try Again
      </Button>
    </div>
  );
}
